module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "groups"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('user-menu'), _vm._v(" "), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "table-id": 'users-groups-list',
      "per-page": _vm.perPage,
      "total": _vm.groupsAmount,
      "tableHeight": "calc(100% - 48px)",
      "link": ""
    },
    on: {
      "refresh": _vm.getUserGroups,
      "create": _vm.addGroup
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.groups),
      callback: function($$v) {
        _vm.groups = $$v
      },
      expression: "groups"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4d16daa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Groups.vue
// module id = 1280
// module chunks = 0